import { EpicIcons, TooltipPosition } from "@constellation-academy/epic-ui";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import { type EditPersonalizedNotificationsTemplateButtonProps } from "./edit-personalized-notifications-template-button.types";
import { Button, ButtonVariant } from "../../../../components/button";
import { Paths } from "../../../../routes/paths";

export const EditPersonalizedNotificationsTemplateButton = ({
	personalizedNotificationTemplateId,
}: EditPersonalizedNotificationsTemplateButtonProps) => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();

	const handleOnClick = () => {
		navigate(
			Paths.personalizedNotificationTemplates.withId(personalizedNotificationTemplateId).edit
				.path,
		);
	};

	return (
		<Button
			icon={EpicIcons.FILE_EDIT}
			variant={ButtonVariant.Strong}
			tooltip={t("personalizedNotificationTemplates.editTooltip")}
			position={TooltipPosition.Left}
			onClick={handleOnClick}
		/>
	);
};
